module.exports = __webpack_public_path__ + "static/media/ao.e8691dea.svg";